<template>
	<div style="width:90%;margin: 1rem auto;">

		<br/>
		<br/>
		<h5 style="text-align: center;">客服中心</h5>
		<br/>
		<br/>
		<br/>
		<br/>
		
		
		<div style="margin: 2rem auto;padding: .5rem 0;">
			<span class="kefu-span">您的称呼:</span>
			<input ref="inputNickname" class="kefu-input" type="text" v-model="nickname"/>
		</div>
		<div style="margin: 1rem auto;padding: .5rem 0;">
			<span class="kefu-span">联系方式:</span>
			<input ref="inputPhone" class="kefu-input" type="text" v-model="phone"/>
		</div>
		<div style="margin: 2rem auto;height: 6rem;">
			<span class="kefu-span">问题诉求:</span>
			<input ref="inputHope" style="height: 6rem;" class="kefu-input" type="text" v-model="hope" placeholder=""/>
		</div>

		<div style="margin-top: 2rem;">
			<span style="text-align: center;display: block;width: 16rem;margin: 2rem auto;  padding: 0.5rem 0; color: white;  background-color: #FF5810;" @click="check();">提交</span>
		</div>


		<!-- 组件使用 -->
		<!-- <foot /> -->
		<syalert ref="syalert_id" />

	</div>
</template>
<style>
.kefu-span
{
	height: 1rem;
	display: block;
	float: left;
	width: 3.5rem;
	font-size: 0.6rem;
}
.kefu-input
{
	height: 1rem;
	box-shadow: rgb(204, 204, 204) 0px 0px 0.1rem;
	float: left;
	width: 14rem;
	border-radius: 0.1rem;
	display: block;
}
.kefu-input:focus
{
	caret-color: #FF5810;
	border: 1px solid #FF5810;
}
</style>
<script>
	// 类库引入
	import sy from "@/sy";

	// 组件引入
	import syalert from '@/components/syalert.vue';
	// import foot from '@/components/foot.vue';

	export default {
		name: 'cashkefu',
		components: {
			// foot,
			syalert,
		},
		data() {
			return {
				nickname: '',
				phone: '',
				hope: '',
			}
		},
		methods: {
			check: function()
			{
				if( this.hope == '' )
				{
					// 获取焦点
					// this.$refs.noteInput.focus();
					// return this.$refs.syalert_id.syalert('请添加订单备注');
				}
				// 重命名实例
				let $_this = this;
				sy.http.get(
				{
					url: this.$root.API + 'PaycashKefu/Add',
					data:
					{
						nickname: this.nickname,
						phone: this.phone,
						hope: this.hope,
					},
					success: function(res)
					{ 
						return $_this.$refs.syalert_id.syalert(res.msg); 
					}
				});
			},
		},
		created() {
			// this.check();
		},
	}
</script>